import { render, staticRenderFns } from "./CouponUserCouponList.vue?vue&type=template&id=eb1ffcb2&lang=pug&"
import script from "./CouponUserCouponList.vue?vue&type=script&lang=ts&"
export * from "./CouponUserCouponList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports